import { render, staticRenderFns } from "./EmojiButton.vue?vue&type=template&id=a58146c4&scoped=true"
import script from "./EmojiButton.vue?vue&type=script&lang=js"
export * from "./EmojiButton.vue?vue&type=script&lang=js"
import style0 from "./EmojiButton.vue?vue&type=style&index=0&id=a58146c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58146c4",
  null
  
)

export default component.exports